export default __webpack_public_path__ + "static/media/w_m_2025_a.9517db0c.jpg";